import _get from 'lodash/get'
import _curry from 'lodash/curry'
import _groupBy from 'lodash/groupBy'

const getLocalState = (state) => _get(state, 'comments')
const getEntries = (state) => _get(getLocalState(state), 'entries', [])
const getEntriesGroupedByKey = _curry((key, state) => _groupBy(getEntries(state), key))
export const getEntriesByParentEntityId = _curry((id, state) => _get(getEntriesGroupedByKey('parentEntityId', state), id, []))
export const getStatus = (state) => _get(getLocalState(state), 'status')
